export default "__VITE_ASSET__93e7502f__"